import styled from 'styled-components';

export const SearchNameSec = styled.div`
  padding: 24px;
  margin: 0 0 10px;
  background: #fff;
  border-radius: 10px;

  @media (max-width: 720px) {
    padding: 24px 12px;
  }
`;

export const NameSearchButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 30px;

  & button {
    width: 100%;
    text-align: center;
    border: none;
    outline: none;
    padding: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border: 1px solid rgb(0 0 0 / 5%);
    color: hsl(0deg 0% 0% / 37%);
    background-color: #63b0a81a;
    font-family: 'Montserrat';
  }
  & .active {
    color: hsl(0deg, 0%, 0%, 80%);
    background-color: #fff;
  }
`;

export const SearchInput = styled.div`
  padding: 6px 10px 30px;
  position: relative;

  & img,
  svg {
    position: absolute;
    top: 21px;
    left: 21px;
    width: 13px;
    height: 13px;
    opacity: 0.8;
  }

  form {
    width: 100%;
  }

  & input {
    width: 100%;
    padding: 12px 14px 12px 32px;
    outline: none;
    font-family: 'Montserrat';
    border: 1px solid rgb(0 0 0 / 10%);
    border-radius: 4px;
  }
`;

export const BabyGenderSec = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  padding: 0px 0 36px;

  .genderImage {
    width: 70px;
    height: 70px;
  }
  & .flex {
    display: flex;
    align-items: center;
    flex-direction: column;
    @media (min-width: 720px) {
      cursor: pointer;
    }

    & div {
      display: flex;
      align-items: center;
      column-gap: 2px;
      margin-top: 4px;
    }
  }

  & label {
    font-size: 13px;
    color: hsl(0deg, 0%, 0%, 87%);
    font-weight: 500;
    padding-top: 2px;
  }
`;

export const NameStart = styled.p`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 500;
  color: hsl(0deg 0% 0% / 87%);
  padding: 0 0 4px 10px;
  text-align: left;
  margin-left: 6px;
`;

export const FindButtonContainer = styled.div`
  margin: 0 10px;
`;

export const FindBtn = styled.button`
  width: 100%;
  height: 38px;
  font-size: 14px;
  line-height: 38px;
  text-align: center;
  font-weight: 500;
  background-color: #ef4e5e;
  color: #fff;
  border-radius: 3px;
  outline: none;
  border: none;
  margin-bottom: 16px;
  cursor: pointer;
  font-family: 'Montserrat';
  position: relative;
  overflow: hidden;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
export const RectangularStrip = styled.div`
  width: 100%;
  height: 5px;
  margin: 0 0 20px;
  background-color: #f9f9f9;
`;
